export default "__VITE_ASSET__DDhBWkj3__"